import { gqlQuery } from './common/apolloClient'
import { gqlInvoice } from './queries/invoices'

export async function getInvoiceDetails(idConta, faturaId, qtdTransacoes) {
  const payload = { idConta, faturaId: parseInt(faturaId), qtdTransacoes: parseInt(qtdTransacoes) }
  const { data: { detalheFaturaPj = {} } = {} } = await gqlQuery(gqlInvoice, payload)

  return detalheFaturaPj
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/invoiceService.js